import React from 'react';
import { Row, Col } from 'reactstrap';
import { useHistory } from 'react-router-dom';

import {
	FaFacebookSquare,
	FaInstagram
} from 'react-icons/fa';

import { Container, Item, FollowUs, ImgLink,Texto } from './styles';

import logo_prefeitura from '~/assets/img/logotipo.png';

const Footer = () => {
	const history = useHistory();

	return (
		<Container>
			<Row>
				<Col md="4">
					<Item className="mb-3">
						<h3>PREFEITURA DE DIVINÓPOLIS</h3>
						<a
							href="https://www.divinopolis.mg.gov.br/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Administração Municipal
						</a>
						<a
							href="https://www.divinopolis.mg.gov.br/portal/servicos/161/legislacao/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Legislação Municipal
						</a>
						{/* <a
							href="http://177.69.246.151/portal/servicos/sonner/transparencia.php"
							target="_blank"
							rel="noopener noreferrer"
						>
							Transparência
						</a> */}
						<a
							href="https://www.divinopolis.mg.gov.br/portal/contato"
							target="_blank"
							rel="noopener noreferrer"
						>
							Contato
						</a>
					</Item>
				</Col>
				<Col md="2">
					<Item className="mb-3">
						<h3>DIVIGEO</h3>
						<a
							// href="/geoportal/article/divigeo"
							// target="_blank"
							onClick={() => history.push('/article/divigeo')}
							// rel="noopener noreferrer"
						>
							Sobre
						</a>
					</Item>
				</Col>
				<Col md="3">
					<Item className="mb-3">
						<h3>LOCALIZAÇÃO</h3>
						<Texto>
						Avenida Paraná, 2.601 - São José
						CEP: 35501-170 
						</Texto>
					</Item>					
					<Item className="mb-3">
						<h3>CONTATO</h3>
						<Texto>
						(37) 3229-6500
						ouvidoria@divinopolis.mg.gov.br
						</Texto>
					</Item>
				</Col>
				<Col md="3">
					<Item className="mb-3">
						<h3>SIGA-NOS</h3>
						<FollowUs>
							<a
								href="https://www.instagram.com/prefeituradivinopolis/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<FaInstagram size={24} />
							</a>
							<a
								href="https://www.facebook.com/prefeituradedivinopolis"
								target="_blank"
								rel="noopener noreferrer"
							>
								<FaFacebookSquare size={24} />
							</a>
							<ImgLink
								href="https://www.divinopolis.mg.gov.br/"
								target="_blank"
								rel="noopener noreferrer"
								alt="Prefeitura de Divinópolis"
								title="Prefeitura de Divinópolis"
								img={{
									src: logo_prefeitura,
									size: '100%',
								}}
							/>
						</FollowUs>
					</Item>
				</Col>
			</Row>
		</Container>
	);
};

export default Footer;
